import type { JSX } from 'react';
import type { RefereeAnswer } from '../types/inspection.types';

interface InspectionAnswersProps {
  answers?: RefereeAnswer[] | null;
}

/**
 * The referee's answers, so a super admin can judge the statement itself
 * instead of only the referee's identity.
 */
export function InspectionAnswers({ answers }: InspectionAnswersProps): JSX.Element | null {
  if (!answers || answers.length === 0) {
    return null;
  }

  return (
    <dl className="space-y-2">
      {answers.map((answer) => (
        <div key={answer.questionId}>
          <dt className="text-xs font-medium text-muted-foreground">{answer.questionText}</dt>
          <dd className="text-sm">{answer.answerText}</dd>
        </div>
      ))}
    </dl>
  );
}
